// Auto-generated file by generate-icons.js


export default {
  prefix: 'waypoint',
  iconName: 'pass',
  icon: [
    14,
    14,
    [],
    "",
    'M 8.8483618,4.0000106 C 9.1443176,4.0000544 9.440217,4.1685512 9.6455512,4.5047659 L 13,9.9999549 9.3032869,10 1,9.999724 4.3546247,4.5045761 C 4.7652937,3.8318349 5.5385252,3.8323816 5.9491942,4.504811 L 6.8802754,6.0301414 C 6.9421091,6.1310678 7.0580559,6.1311858 7.1196562,6.0302489 L 8.050982,4.5045191 C 8.2561998,4.1681491 8.552406,3.9999615 8.8483618,4 Z M 9.009533,6.5353743 C 8.6787812,6.5353783 8.3480168,6.7233579 8.1185321,7.0992004 L 7.6765716,7.8229853 C 7.4112701,8.2576505 6.9114324,8.2573307 6.6461311,7.8223537 L 6.2041949,7.0990757 C 5.7452256,6.3473907 4.8811445,6.3471505 4.4221756,7.0988368 L 2.8860047,9.6158039 4.7018096,7.3362812 C 5.0371115,6.9149279 5.5681281,6.9428665 5.8772968,7.3979646 L 6.6690411,8.5618347 C 6.9324759,8.949442 7.3905188,8.9495641 7.6539538,8.5619488 L 8.4453971,7.3978903 C 8.7547988,6.9427922 9.2858584,6.9147116 9.6213938,7.336065 L 11.436854,9.6158066 9.9005521,7.0990332 C 9.6710675,6.7231894 9.3402849,6.5353743 9.009533,6.5353743 Z'
  ]
}